import { useCallback } from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";

import CardMedia from "@mui/material/CardMedia";

type PhotoPickerProps = {
  open: boolean;
  onClose: () => void;
  imgSrc: string;
};

export default function ExpandPhoto({
  open,
  onClose,
  imgSrc,
}: PhotoPickerProps) {
  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xl">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{
          p: 4,
        }}
      >
        {imgSrc ? (
          <CardMedia
            sx={{
              minHeight: 500,
              maxHeight: "calc(100dvh - 200px)",
            }}
            component="img"
            alt="Your Image"
            height="auto"
            image={imgSrc}
            title="Your Image Title"
          />
        ) : (
          "No image to display"
        )}
      </Box>
    </Dialog>
  );
}
